import React from 'react';
import { useTranslation } from 'react-i18next';

import clsx from 'clsx';

import { Button, ModalBody } from '@adeccoux/tag-ds';
import { Box, Modal } from '@mui/material';

import styles from './SuccessPageDialog.module.scss';
interface SuccessPageDialogProps {
  isVisible: boolean;
  setIsDataCheckerSuccess: any;
  handleSubmit?: () => Promise<void> | void;
}
const SuccessPageDialog: React.FC<SuccessPageDialogProps> = ({ isVisible, setIsDataCheckerSuccess, handleSubmit }) => {
  const { t } = useTranslation(['documents']);
  return (
    <Modal open={isVisible}>
      <Box className={clsx('tag-ds', styles.modal)}>
        <ModalBody style={{ marginBottom: 48 }}>
          <Box mb={2} mt={4} className="tag-ds" display="flex" flexDirection="column" alignItems="center">
            <img src="/images/success.svg" alt="404" />
            <h3 className={styles.modal__mainDiv__successHeading}>
              {t('documents:DATACHECKER.idVerifySuccess.label')}
            </h3>
            <p className={styles.modal__mainDiv__successDescription}>
              {t('documents:DATACHECKER.idVerifySuccess.description')}
            </p>
            <Button
              style={{ marginTop: '80px' }}
              className="button-primary"
              onClick={() => {
                setIsDataCheckerSuccess(false);
                handleSubmit && handleSubmit();
              }}
            >
              {t('documents:DATACHECKER.next.label')}
            </Button>
          </Box>
        </ModalBody>
      </Box>
    </Modal>
  );
};
export default SuccessPageDialog;
